import * as React from 'react';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import { IDisplayValue } from '../../ts/Interfaces';
import CodeField from '../../ts/CodeField';

export interface IExpressionEditProps {
    value: string;
    dataSourceID: number;
    variables: IDisplayValue[];
    errorText: string;
    glob: IGlob;
    onChange(value: string): void;
}

export function ExpressionEdit(props: IExpressionEditProps) {
    const Component = CodeField.EditComponent;

    let messageElement: React.JSX.Element;

    if (props.errorText != null && props.errorText.length > 0) {
        messageElement = (
            <div className="error-message">
                <span className="glyphicon glyphicon-minus-sign" />
                <span className="error-text">{props.errorText}</span>
            </div>
        );
    } else {
        messageElement = <span className="glyphicon glyphicon-check" />;
    }

    return (
        <div className="expression-edit">
            <div className="messages">{messageElement}</div>

            <div>
                <Component
                    value={props.value}
                    wordWrap={true}
                    setFocus={true}
                    dataSourceID={props.dataSourceID}
                    initialHeight={300}
                    showFuncList={true}
                    showAttrList={true}
                    putAttrAsArray={true}
                    variables={props.variables}
                    glob={props.glob}
                    onChange={props.onChange}
                />
            </div>
        </div>
    );
}
